<template>
    <div id="user-home">
        <div class="header">
            <h1>Istraži</h1>
            <router-link to="/">
                <img class="return-to-web" src="../../assets/app-icons/home/return-to-web.svg" alt="Povratak na početnu" />
            </router-link>
            <router-link to="/app/settings">
                <img class="settings" src="../../assets/app-icons/home/settings.svg" alt="Postavke računa" />
            </router-link>
            <img class="signout" v-on:click="signout" src="../../assets/app-icons/home/signout.svg" alt="Odjava" />
        </div>
        <div class="active-lectures" v-if="this.currentLectures.length">
            <div class="lecture-container" v-if="this.currentLectures[0]">
                <div class="active-label">
                    <img src="../../assets/app-icons/home/ongoing.svg" alt="U tijeku" />
                    U TIJEKU
                </div>
                <router-link v-bind:to="{ name: 'app-schedule', params: { popupId: this.currentLectures[0].id, type: this.currentLectures[0].type }}">
                    <div class="lecture-header">
                        <div class="time">{{ this.currentLectures[0].starts | filterTimeFromDate }}-{{ this.currentLectures[0].ends | filterTimeFromDate }}</div>
                        <div class="theme dev" v-if="this.currentLectures[0].theme === 'Dev'">DEV</div>
                        <div class="theme design" v-else-if="this.currentLectures[0].theme === 'Design'">DESIGN</div>
                        <div class="theme tech" v-else-if="this.currentLectures[0].theme === 'Tech'">TECH</div>
                        <div class="theme marketing" v-else-if="this.currentLectures[0].theme === 'Marketing'">MARKETING</div>
                    </div>
                    <div class="lecture-title">
                        {{this.currentLectures[0].name}}
                    </div>
                </router-link>
            </div>
            <div class="lecture-container" v-if="this.currentLectures[1]">
                <div class="next-label">
                    SLIJEDI
                </div>
                <router-link v-bind:to="{ name: 'app-schedule', params: { popupId: this.currentLectures[1].id, type: this.currentLectures[1].type }}">
                    <div class="lecture-header">
                        <div class="time">{{ this.currentLectures[1].starts | filterTimeFromDate }}-{{ this.currentLectures[1].ends | filterTimeFromDate }}</div>
                        <div class="theme dev" v-if="this.currentLectures[1].theme === 'Dev'">DEV</div>
                        <div class="theme design" v-else-if="this.currentLectures[1].theme === 'Design'">DESIGN</div>
                        <div class="theme tech" v-else-if="this.currentLectures[1].theme === 'Tech'">TECH</div>
                        <div class="theme marketing" v-else-if="this.currentLectures[0].theme === 'Marketing'">MARKETING</div>
                    </div>
                    <div class="lecture-title">
                        {{this.currentLectures[1].name}}
                    </div>
                </router-link>
            </div>
        </div>
        <div class="schedule-cta">
            <div class="schedule-cta-header">
                <div>
                    RASPORED
                </div>
                <router-link to="/app/schedule">
                    <span>VIDI RASPORED</span>
                    <img src="../../assets/app-icons/home/open-arrow.svg" alt="Vidi raspored" />
                </router-link>
            </div>
            <div class="schedule-categories-cta">
                <div class="lectures">
                    <router-link v-bind:to="{ name: 'app-schedule', params: { shown: 'lecture' }}">
                        <div>
                            <img src="../../assets/app-icons/schedule/chat.svg" />
                            Predavanja
                        </div>
                    </router-link>
                </div>
                <div class="workshops">
                    <router-link v-bind:to="{ name: 'app-schedule', params: { shown: 'workshop' }}">
                        <div>
                            <img src="../../assets/app-icons/schedule/laptop.svg" />
                            Radionice
                        </div>
                    </router-link>
                </div>
                <div class="campfire-talks">
                    <router-link v-bind:to="{ name: 'app-schedule', params: { shown: 'campfire' }}">
                        <div>
                            <img src="../../assets/app-icons/schedule/heart.svg" />
                            Campfire
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="featured-events" v-if="featuredEvents.length">
            <div class=featured-events-header>ISTAKNUTO</div>
            <div class="featured-events-container">
                <div class="featured-event" v-for="event in featuredEvents" v-bind:key="event.id">
                    <router-link v-bind:to="{ name: 'app-schedule', params: { popupId: event.id, type: event.type }}">
                        <img v-bind:src="getFeaturedEventImage(event.starts)" />
                        <div>
                            {{event.name}}
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="fly-talks">
            <div class="fly-talks-header">Fly Talks</div>
            <div class="fly-talks-features">
                <span>
                    <img src="../../assets/app-icons/home/job.svg" />
                    Pronađi posao
                </span>
                <span>
                    <img src="../../assets/app-icons/home/experience.svg" />
                    Obogati iskustva
                </span>
                <span>
                    <img src="../../assets/app-icons/home/networking.svg" />
                    Stekni vrijedna poznanstva
                </span>
            </div>
            <div class="fly-talks-cta">
                <router-link to="/app/fly-talks">PRIJAVI SE</router-link>
                <router-link to="/app/fly-talks">
                    <span>SAZNAJ VIŠE</span>
                    <img src="../../assets/app-icons/home/open-arrow.svg" alt="Saznaj više o fly talkovima" />
                </router-link>
            </div>
        </div>
        <div class="prize-game">
            <div class="prize-game-header">
                <div>
                    NAGRADNA IGRA
                </div>
                <router-link to="/app/prizes">
                    <span>SAZNAJ VIŠE</span>
                    <img src="../../assets/app-icons/home/open-arrow.svg" alt="Saznaj više o nagradnoj igri" />
                </router-link>
            </div>
            <div class="prize-game-content">
                <div>
                    <img src="../../assets/visuals/prizes.png" />
                </div>
                <div class="prize-game-cta">
                    <div class="title">Skupljaj bodove i osvoji velike nagrade</div>
                    <router-link to="/app/prizes">UPIŠI KOD</router-link>
                </div>
            </div>
            <div v-bind:style="{visibility: progressBarWidth !== null ? 'visible' : 'hidden'}" class="progress-bar-container">
                <div v-bind:style="{width: `${progressBarWidth}px`}" class="progress-bar-fill"></div>
                <img class="start-briefcase" src="../../assets/app-icons/home/job.svg" />
                <div class="milestone">
                    <hr>
                    <img src="../../assets/app-icons/home/prize-bar/rocket.svg" />
                </div>
                <div class="milestone">
                    <hr>
                    <img src="../../assets/app-icons/home/prize-bar/astronaut.svg" />
                </div>
                <div class="milestone">
                    <hr>
                    <img src="../../assets/app-icons/home/prize-bar/spaceship.svg" />
                </div>
                <div class="milestone">
                    <hr>
                    <img src="../../assets/app-icons/home/prize-bar/comet.svg" />
                </div>
                <div class="milestone">
                    <hr>
                    <img src="../../assets/app-icons/home/prize-bar/lunar-flag.svg" />
                </div>
            </div>
        </div>
        <div class="exhibition-areas">
            <div class="exhibition-areas-header">
                <div>
                    IZLOŽBENI PROSTORI
                </div>
                <router-link to="/app/map">
                    <span>VIDI MAPU</span>
                    <img src="../../assets/app-icons/home/open-arrow.svg" alt="Saznaj više o nagradnoj igri" />
                </router-link>
            </div>
            <div class="exhibition-areas-sponsors">
                <div v-bind:class="getSponsorNameNormalized(sponsor.name)" v-for="sponsor in sponsors" v-bind:key="sponsor.id">
                    <router-link v-bind:to="{ name: 'app-map', params: { sponsorName: sponsor.name }}">
                        <img v-bind:src="getLogo(sponsor.name)" v-bind:alt="`${sponsor.name} logo`" />
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Home',
        data() {
            return {
                currentLectures: [],
                featuredEvents: [],
                progressBarContainer: {},
                progressBarWidth: null,
                sponsors: [],
                eventForModal: {},
                detailsModalVisible: false
            }
        },
        methods: {
            getFeaturedEventImage: function(startDateTime) {
                return require(`../../assets/events/featured-${startDateTime.replace(/\s/g, '').replace(/:/g,'-')}.jpg`);
            },
            getLogo: function (sponsorName) {
                return require(`../../assets/companies/logos/${this.getSponsorNameNormalized(sponsorName)}.png`);
            },
            getSponsorNameNormalized: function (sponsorName) {
                return sponsorName.replace(/\s/g, '').toLowerCase();
            },
            signout: function() {
                localStorage.removeItem('token');
                this.$router.push('/');
            }
        },
        created() {
            this.$axios.get(`${this.$API_URL}/events/active-and-next`).then(response => {
                this.currentLectures = response.data;
            });
            this.$axios.get(`${this.$API_URL}/events/featured`).then(response => {
                this.featuredEvents = response.data;
            });
            this.$axios.get(`${this.$API_URL}/companies/all-sponsors`).then(response => {
                this.sponsors = response.data.filter(sponsor => 
                    sponsor.sponsorCategory === 'General' || 
                    sponsor.sponsorCategory === 'Gold' || 
                    sponsor.sponsorCategory === 'Silver')
                    .sort((firstSponsor, secondSponsor) => 
                        firstSponsor.name < secondSponsor.name ? -1 : 1);
            });
        },
        mounted() {
            this.progressBarContainer = document.querySelector('.progress-bar-container');
            let milestones = document.getElementsByClassName('milestone');
            this.$axios.get(`${this.$API_URL}/user/points`).then(response => {
                this.progressBarWidth = response.data / 1000 * this.progressBarContainer.offsetWidth;
                let percentage = response.data / 1000;
                let numberOfBarsFulfilled = 0;
                switch(true)
                {
                    case (percentage > 0.95):
                        numberOfBarsFulfilled = 5;
                        break;
                    case (percentage > 0.79):
                        numberOfBarsFulfilled = 4;
                        break;
                    case (percentage > 0.58):
                        numberOfBarsFulfilled = 3;
                        break;
                    case (percentage > 0.45):
                        numberOfBarsFulfilled = 2;
                        break;
                    case (percentage > 0.24):
                        numberOfBarsFulfilled = 1;
                        break;
                }
                for(let i = 0; i < numberOfBarsFulfilled; i++)
                    milestones[i].classList.add('active');
            });
        }
    }
</script>

<style scoped>
#user-home {
    margin-top: 20px;
    padding-left: 20px;
}

#user-home h1 {
    font-size: 22px;
    font-weight: 800;
    line-height: 26px;
    margin-right: auto;
}

.header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.header img {
    height: 20px;
    margin-right: 15px;
}

.header img.settings,
.header img.signout {
    filter: invert(78%) sepia(9%) saturate(3087%) hue-rotate(121deg) brightness(92%) contrast(83%);
}

.header img.signout:hover {
    cursor: pointer;
}

.theme {
    color: white;
    font-size: 10px;
    font-weight: 700;
    padding: 2px 6px;
    margin-right: 10px;
    border-radius: 5px;
}

.theme.dev {
    background-color: #30cec1;
}

.theme.design {
    background-color: #FF575F;
}

.theme.tech {
    background-color: #2C373F;
}

.theme.marketing {
    background-color: #D6BD42;
}

.time {
    font-size: 14px;
    opacity: 0.5;
    margin-right: 15px;
}

.active-lectures {
    display: flex;
}

.active-lectures:after {
    content: '';
    flex: 0 0 10px;
}

.lecture-container {
    background-color: rgba(0, 0, 0, 0.015);
    border-radius: 7px;
    padding: 10px 10px 20px 10px;
    margin-right: 20px;
}


.active-label,
.next-label {
    font-size: 12px;
    font-weight: 400;
    line-height: 15px;
    letter-spacing: 0.24px;
    margin-bottom: 5px;
}

.active-label {
    color: #30cec1;
    display: flex;
    align-items: center;
}

.active-label img {
    margin-right: 5px;
}

.next-label {
    color: #2C373F;
}

.lecture-header {
    color: black;
    display: flex;
    margin-bottom: 5px;
}

.lecture-title {
    color: black;
    font-size: 18px;
    font-weight: 700;
    letter-spacing: -0.2px;
    line-height: 24px;
}

.active-lectures {
    margin-top: 20px;
    overflow-x: auto;
}

.schedule-cta {
    margin-top: 20px;
}

.schedule-cta-header {
    display: flex;
    font-size: 12px;
    letter-spacing: 0.54px;
    line-height: 15px;
    margin-bottom: 10px;
}

.schedule-cta-header a {
    margin-left: auto;
    margin-right: 20px;
}

.schedule-cta-header a span {
    opacity: 0.42;
    margin-right: 5px;
    text-decoration: none;
    color: black;
}

.schedule-categories-cta {
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
    color: white;
    height: 150px;
    position: relative;
}

.schedule-categories-cta:after {
    content: '';
    flex: 0 0 10px;
}

.schedule-categories-cta img {
    filter: invert(100%);
}

.schedule-categories-cta .lectures,
.schedule-categories-cta .workshops,
.schedule-categories-cta .campfire-talks {
    flex: 0 0 115px;
    border-radius: 7px;
    padding-left: 10px;
    margin-right: 10px;
}

.schedule-categories-cta .lectures:hover,
.schedule-categories-cta .workshops:hover,
.schedule-categories-cta .campfire-talks:hover {
    cursor: pointer;
}

.schedule-categories-cta .lectures,
.schedule-categories-cta .workshops,
.schedule-categories-cta .campfire-talks {
    background-size: 100% 100%;
    background-repeat: no-repeat;
}

.schedule-categories-cta .lectures {
    background-image: url('../../assets/header.jpg');
}

.schedule-categories-cta .workshops {
    background-image: url('../../assets/grid/workshop.jpg');
}

.schedule-categories-cta .campfire-talks {
    background-image: url('../../assets/grid/mingle.jpg');
}

.schedule-categories-cta .lectures div,
.schedule-categories-cta .workshops div,
.schedule-categories-cta .campfire-talks div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    position: absolute;
    bottom: 10px;
}

.schedule-categories-cta div a {
    display: inline-block;
    color: white;
    width: 100%;
    height: 100%;
}

.featured-events-container {
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
    height: 150px;
}

.featured-events-container:after {
    content: '';
    flex: 0 0 10px;
}

.featured-event {
    flex: 0 0 250px;
    margin-right: 20px;
    position: relative;
}

.featured-event img {
    height: 100%;
    width: 100%;
    border-radius: 7px;
}

.featured-event:hover {
    cursor: pointer;
}

.featured-events-header {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.54px;
    line-height: 15px;
    margin-top: 20px;
    margin-bottom: 5px;
}

.featured-event div {
    color: white;
    position: absolute;
    bottom: 10px;
    left: 10px;
}

.fly-talks {
    background-color: #2c373f;
    margin: 20px 0 0 -20px;
    color: white;
    padding: 20px 0 20px 20px;
}

.fly-talks a {
    text-decoration: none;
    color: white;
}

.fly-talks-header {
    font-size: 18px;
    font-weight: 700;
    letter-spacing: -0.2px;
    margin-bottom: 20px;
}

.fly-talks-features {
    display: flex;
    flex-wrap: wrap;
}

.fly-talks-features span {
    font-size: 14px;
    display: flex;
    align-items: flex-start;
    margin-right: 15px;
    margin-bottom: 15px;
}

.fly-talks-features span img {
    margin-right: 10px;
}

.fly-talks-cta {
    display: flex;
    align-items: center;
    margin-top: 10px;
}

.fly-talks-cta a:first-of-type {
    background-color: #30cec1;
    border-radius: 4px;
    box-shadow: 0 2px 3px 0 rgba(0,0,0,0.07);
    padding: 5px 12px;
    font-weight: 700;
}

.fly-talks-cta a:last-of-type {
    margin-left: auto;
    margin-right: 20px;
}

.fly-talks-cta a span {
    font-size: 12px;
    opacity: 0.86;
    margin-right: 5px;
}

.fly-talks-cta a:last-of-type img {
    filter: invert(100%);
}

.prize-game {
    margin-top: 30px;
    background-color: rgba(0, 0, 0, 0.02);
    border-radius: 12px;
    padding-top: 10px;
    padding-left: 10px;
    margin-left: -10px;
    margin-right: 10px;
    padding-bottom: 40px;
}

.prize-game-header {
    display: flex;
    font-size: 12px;
}

.prize-game-header a {
    margin-left: auto;
    margin-right: 10px;
}

.prize-game-header a span {
    color: black;
    opacity: 0.42;
    margin-right: 5px;
}

.prize-game-content {
    display: flex;
    justify-content: center;
    margin-top: 30px;
}

.prize-game-content div {
    flex-basis: 45%;
    max-width: 250px;
}

.prize-game-content div:first-of-type {
    margin-right: 20px;
}

.prize-game-content div img {
    width: 100%;
}

.prize-game-cta .title {
    font-size: 16px;
    font-weight: 700;
}

.prize-game-cta a {
    display: inline-block;
    margin-top: 10px;
    color: white;
    background-color: #30cec1;
    border-radius: 4px;
    box-shadow: 0 2px 3px 0 rgba(0,0,0,0.07);
    padding: 6px 14px;
    font-weight: 700;
}

.progress-bar-container {
    position: relative;
    margin-top: 40px;
    margin-right: 20px;
    border-radius: 8px;
    height: 8px;
    background-color: rgba(0, 0, 0, 0.1);
}

.progress-bar-fill {
    border-radius: 8px;
    height: 8px;
    background-color: #30cec1;
    max-width: 100%;
}

.start-briefcase {
    position: absolute;
    top: -25px;
    left: 5px;
}

.milestone {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
}

.milestone hr {
    transform: rotate(90deg);
    width: 12px;
    opacity: 0.25;
    margin: 8px 0;
}

.milestone img {
    filter: brightness(0) saturate(100%);
    opacity: 0.25;
    width: 20px;
    height: 20px;
}

.milestone:nth-of-type(odd) {
    top: -27px;
    flex-direction: column-reverse;
}

.milestone:nth-of-type(even) {
    bottom: -25px;
    flex-direction: column;
}

.milestone:nth-of-type(2) {
    left: 22%;
}

.milestone:nth-of-type(3) {
    left: 43%;
}

.milestone:nth-of-type(4) {
    left: 56%;
}

.milestone:nth-of-type(5) {
    left: 77%;
}

.milestone:nth-of-type(6) {
    left: 93%;
}

.milestone.active img {
    filter: invert(78%) sepia(9%) saturate(3087%) hue-rotate(121deg) brightness(92%) contrast(83%);
    opacity: 1;
}

.exhibition-areas {
    margin-top: 30px;
}

.exhibition-areas-header {
    display: flex;
    font-size: 12px;
}

.exhibition-areas-header a {
    margin-left: auto;
    margin-right: 20px;
}

.exhibition-areas-header a span {
    color: black;
    opacity: 0.42;
    margin-right: 5px;
}

.exhibition-areas-sponsors {
    margin-top: 20px;
    padding-left: 10px;
    padding-right: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}

.exhibition-areas-sponsors div {
    flex-basis: 28%;
    margin-bottom: 20px;
}

.exhibition-areas-sponsors a img {
    width: 100%;
}

.atos img,
.bundesdruckerei img {
  transform: scale(0.6);
}

.hrprodigy img  {
  transform: scale(1.1);
}

.extensionengine img {
    transform: scale(1.1);
}

.hrcloud img,
.infobip img,
.netmedia img {
  transform: scale(1.1);
}

.dobartek\.hr img {
  transform: scale(1.3);
}

.ericssonnikolatesla img {
    transform: scale(0.5);
}

.rimacautomobili img {
    transform: scale(1.4);
}
</style>